module.exports = __webpack_public_path__ + "media/img/covers/auth-side-cover-2635f955049ce9a091995b5d29d9bb4d.jpg";